import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Reel } from "../GameComponents/Reel";
import { Symbol } from "../GameComponents/Symbol";
import { Settings } from "./Settings";

@engineComponent(ComponentTypes.DisplayObject)
export class ReelExtended extends Reel {
    public static Tease: boolean = false;

    public showSymbols(useTransform: boolean = false): void {
        super.showSymbols();
        this.sortSymbols();
    }

    public sortSymbols(): void {
        if (!this.symbols.hasZindex) {
            return;
        }
        let addQueue: Symbol[] = [];
        this.currentSymbols.forEach((symbol) => {
            addQueue.push(<Symbol>symbol);
        });
        addQueue.sort((a, b) => a.zIndex - b.zIndex);
        addQueue.forEach((symbol) => {
            this.addChild(symbol);
        });
    }

    protected getSymbol(symbolId: number, symbolCase: string, fromStrip: boolean): Symbol {
        if (ReelExtended.Tease) {
            if (symbolId + 1 === Settings.SymbolTeasing) {
                symbolCase = Symbol.CaseNormal;
            } else {
                symbolCase = Symbol.CaseTease;
            }
        }
        return this.symbols.getSymbol(symbolId, symbolCase);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ReelExtended.ts
 **/